import Hls, { ErrorData } from "hls.js";

const SOURCE_ID = "formulaAeMediaSource";

export class HlsVideoSource {
  private hls: Hls | null = null;

  matches(video: HTMLVideoElement, source: string): boolean {
    return video.dataset[SOURCE_ID] === source;
  }

  load(video: HTMLVideoElement, source: string): void {
    this.destroy();
    video.dataset[SOURCE_ID] = source;
    if (!new URL(source, document.baseURI).pathname.endsWith(".m3u8")) {
      video.src = source;
      video.load();
      return;
    }
    if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = source;
      video.load();
      return;
    }
    if (!Hls.isSupported()) throw new Error("このブラウザはHLS再生に対応していません。");
    const hls = new Hls({
      maxBufferLength: 8,
      maxMaxBufferLength: 16,
      backBufferLength: 4,
      startFragPrefetch: true,
      capLevelToPlayerSize: true,
      enableWorker: true,
    });
    hls.on(Hls.Events.ERROR, (_event, data: ErrorData) => {
      if (!data.fatal) return;
      if (data.type === Hls.ErrorTypes.NETWORK_ERROR) hls.startLoad();
      else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) hls.recoverMediaError();
      else {
        this.destroy();
        video.dispatchEvent(new Event("error"));
      }
    });
    this.hls = hls;
    hls.attachMedia(video);
    hls.loadSource(source);
  }

  destroy(): void {
    this.hls?.destroy();
    this.hls = null;
  }
}
